export default __webpack_public_path__ + "static/media/linkedin.ada11cda.svg";